(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHTOverlay() {
    const overlay = document.querySelector('[data-ht-overlay]');
    if (!overlay) return;

    // Always force visible on Home load (no persistence)
    overlay.hidden = false;
    overlay.removeAttribute('hidden');
    overlay.style.display = 'grid';

    const hideBtn = overlay.querySelector('[data-ht-hide]');
    const joinBtn = overlay.querySelector('[data-ht-join]');
    const shopBtn = overlay.querySelector('[data-ht-shop]');
    const labelEl = overlay.querySelector('[data-ht-label]');
    const valueEl = overlay.querySelector('[data-ht-value]');
    const titleEl = overlay.querySelector('.ht-overlay__title');
    const blocks  = Array.from(overlay.querySelectorAll('[data-ht-block]'));

    if (!labelEl || !valueEl) return;

    // Drop time (PT). Feb 13 is PST (-08:00).
    const tDrop = new Date('2026-02-13T13:02:00-08:00').getTime();

    // Block fill start (site launch moment)
    const tBuildStart = new Date('2026-01-01T13:02:00-08:00').getTime();

    labelEl.textContent = "";

    let isScramblingNumbers = false;

    // Clear any prior interval so editor reloads don't stack timers
    if (overlay._htIntervalId) {
      clearInterval(overlay._htIntervalId);
      overlay._htIntervalId = null;
    }

    function fmt(ms){
      const s = Math.max(0, Math.floor(ms/1000));
      const d = Math.floor(s/86400);
      const h = Math.floor((s%86400)/3600);
      const m = Math.floor((s%3600)/60);
      const ss = s%60;
      return `${d}D ${String(h).padStart(2,'0')}H ${String(m).padStart(2,'0')}M ${String(ss).padStart(2,'0')}S`;
    }

    function getCountdownText(){
      const now = Date.now();
      return (now < tDrop) ? fmt(tDrop - now) : '00D 00H 00M 00S';
    }

    function setBlocks(filledCount){
      if (!blocks.length) return;

      for (const b of blocks) b.classList.remove('is-filled','is-cursor');

      for (let i = 0; i < filledCount && i < blocks.length; i++){
        blocks[i].classList.add('is-filled');
      }

      if (filledCount < blocks.length) {
        const cursorIndex = Math.min(filledCount, blocks.length - 1);
        blocks[cursorIndex].classList.add('is-cursor');
      }
    }

    function tick(){
      if (overlay.hidden) return;

      if (!isScramblingNumbers) {
        valueEl.textContent = getCountdownText();
      }

      const now = Date.now();
      const denom = Math.max(1, (tDrop - tBuildStart));
      const prog  = Math.min(1, Math.max(0, (now - tBuildStart) / denom));

      const total = blocks.length || 24;
      const naturalFilled = Math.floor(prog * total);
      const filled = Math.min(total, Math.max(3, naturalFilled));

      if (prog >= 0.999 || now >= tDrop) setBlocks(total);
      else setBlocks(filled);
    }

    function attachScramble(el, getFinalText, { onStart, onEnd, runOnLoad } = {}) {
      if (!el || reduceMotion) return;

      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
      let running = false;

      // lock final title text once per page load
      if (el === titleEl && !el.dataset.htFinal) el.dataset.htFinal = el.textContent;

      function run() {
        if (running || overlay.hidden) return;
        running = true;
        onStart?.();

        const original = (typeof getFinalText === "function") ? getFinalText() : el.textContent;
        const len = original.length;

        let frame = 0;
        const maxFrames = Math.max(10, len);
        const speed = 22;

        const t = setInterval(() => {
          const out = original.split("").map((c, i) => {
            if (c === " ") return " ";
            if (i < frame) return c;
            return chars[Math.floor(Math.random() * chars.length)];
          }).join("");

          el.textContent = out;

          frame++;
          if (frame > maxFrames) {
            clearInterval(t);
            el.textContent = original;
            running = false;
            onEnd?.();
          }
        }, speed);
      }

      el.onmouseenter = run;
      el.onfocus = run;

      if (runOnLoad) setTimeout(run, 250);
    }

    tick();

    attachScramble(titleEl, () => titleEl.dataset.htFinal || titleEl.textContent, {
      onStart: () => titleEl.classList.add('ht-scrambling'),
      onEnd:   () => titleEl.classList.remove('ht-scrambling'),
      runOnLoad: true
    });

    attachScramble(valueEl, () => getCountdownText(), {
      onStart: () => {
        isScramblingNumbers = true;
        valueEl.classList.add('ht-scrambling');
      },
      onEnd: () => {
        isScramblingNumbers = false;
        valueEl.classList.remove('ht-scrambling');
        valueEl.textContent = getCountdownText();
      },
      runOnLoad: true
    });

    // Join list scroll
    if (joinBtn) {
      joinBtn.onclick = () => {
        // keep overlay showing every time: hide only for this visit
        overlay.hidden = true;
        overlay.setAttribute('hidden','');
        overlay.style.display = 'none';

        if (overlay._htIntervalId) {
          clearInterval(overlay._htIntervalId);
          overlay._htIntervalId = null;
        }

        const emailInput = document.querySelector(
          'footer input[type="email"], input[name="contact[email]"], .newsletter input[type="email"]'
        );
        if (emailInput) {
          emailInput.scrollIntoView({ behavior: "smooth", block: "center" });
          setTimeout(() => emailInput.focus(), 400);
        }
      };
    }

    // Hide (no storage)
    if (hideBtn) {
      hideBtn.onclick = () => {
        overlay.hidden = true;
        overlay.setAttribute('hidden','');
        overlay.style.display = 'none';
        if (overlay._htIntervalId) {
          clearInterval(overlay._htIntervalId);
          overlay._htIntervalId = null;
        }
      };
    }

    overlay._htIntervalId = setInterval(tick, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHTOverlay);
  } else {
    initHTOverlay();
  }

  document.addEventListener("shopify:section:load", initHTOverlay);
  window.addEventListener("pageshow", initHTOverlay);
})();
